import {
  hotspotIcon,
  generateCustomIconXml
} from '~js/helpers'

const getMarkerPointXml = function (marker, ath, atv, useCustomIcon, index, markerScale) {
  const nextBuildingIndex = parseInt(marker.nextBuildingIndex, 10) || 1
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6
  if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    const inverserotation = (marker.coordinatePlane === 3)
    const rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    const rz = marker.rotation.z
    return `<hotspot
      name="marker_${marker.objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      distorted="true"
      inverserotation="${inverserotation}"
      rx="${rx}"
      ry="${ry}"
      rz="${rz}"
      mipmapping="true"
      enabled="${!marker.disabled}"
      capture="false"
      ${generateCustomIconXml(marker)}
      onclick="change_building(${marker.nextBuildingId}, ${nextBuildingIndex || 1});"
      ondown="change_building(${marker.nextBuildingId}, ${nextBuildingIndex || 1});"
      onover="marker_mousein(${marker.objectId}, ${index}, 'point_building');"
      onout="marker_mouseout(${marker.objectId}, ${index}, 'point_building');" />`
  }
  return `<hotspot
    name="marker_${marker.objectId}"
    style="${hotspotIcon(marker, useCustomIcon)}"
    scale="${markerScale}"
    ath="${ath}"
    atv="${atv}"
    alpha="${opacity}"
    zorder="${marker.index}"
    enabled="${!marker.disabled}"
    capture="false"
    ${generateCustomIconXml(marker)}
    onclick="change_building(${marker.nextBuildingId}, ${nextBuildingIndex || 1});"
    ondown="change_building(${marker.nextBuildingId}, ${nextBuildingIndex || 1});"
    onover="marker_mousein(${marker.objectId}, ${index}, 'point_building');"
    onout="marker_mouseout(${marker.objectId}, ${index}, 'point_building');" />`
}

export default getMarkerPointXml
